import { useState } from "react";
import { faqs } from "@/mocks/siteContent";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="section-pad scroll-mt-20 bg-background-50">
      <div className="container-x">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <p className="text-sm font-medium tracking-wide text-primary-600">常见问题</p>
            <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">你可能想问的事</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于提取范围、使用边界与隐私，这里先说清楚。还有疑问也可以把问题记下来，稍后回到页面留言反馈。
            </p>
            <a
              href="#footer"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-chat-3-line" aria-hidden="true" />
              咨询与反馈
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? null : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
                    >
                      <span className={`text-sm font-bold md:text-base ${open ? "text-primary-700" : "text-foreground-900"}`}>
                        {f.q}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all ${
                          open
                            ? "rotate-180 border-primary-200 bg-primary-100 text-primary-700"
                            : "border-background-300 text-foreground-500"
                        }`}
                      >
                        <i className="ri-arrow-down-s-line text-lg" aria-hidden="true" />
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
    </section>
  );
}